/**
 * 5.0.8 Profile - Enterprise Admin
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3631%3A19753
 */
// @react
import React from 'react'
// @design
// @components
import DocumentTitle from 'react-document-title'
import Grid from '@bit/atd.web.grid'
// @module Components
import EnterpriseAdminTabs from 'modules/profile/components/EnterpriseAdminTabs'
import PageWrapper from 'modules/profile/components/PageWrapper'

type PropsType = any
const title = 'Profile - Enterprise Admin'

const EnterpriseAdmin = (props: PropsType) => {
  /******************************************
   * PROPS
   ******************************************/

  /******************************************
   * STATE
   ******************************************/

  /******************************************
   * HOOKS
   ******************************************/

  /******************************************
   * FUNCTIONS
   ******************************************/

  /**
   * props
   */
  return (
    <PageWrapper>
      <DocumentTitle title={`${title} | ATD`}>
        <>
          <Grid container>
            <Grid item xs={12}>
              <h1>{title}</h1>
            </Grid>

            <Grid item xs={12}>
              <EnterpriseAdminTabs />
            </Grid>
          </Grid>
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default EnterpriseAdmin
